export default __webpack_public_path__ + "static/media/Principal’s Office.77ebbf25.jpg";